import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
})
export class AboutComponent {}
